export const ShopifyPlan = {
    ShopifyPlus: 'Shopify Plus',
    Basic: 'Basic',
    Advanced: 'Advanced',
    Shopify: 'Shopify',
    DeveloperPreview: 'Developer Preview',
    PauseAndBuild: 'Pause and Build',
    ShopifyPlusPartnerSandbox: 'Shopify Plus Partner Sandbox',
    PlusTrial: 'Plus Trial',
    Frozen: 'Frozen',
    Development: 'Development',
    Staff: 'Staff',
    StaffBusiness: 'Staff Business',
    ShopifyStarter: 'Shopify Starter',
    Cancelled: 'Cancelled',
    OpenLearning: 'Open Learning',
    Custom: 'Custom',
    ShopifyAlumni: 'Shopify Alumni',
    Trial: 'Trial',
    Grow: 'Grow',
};
//# sourceMappingURL=shopifyPlans.js.map